// extracted by mini-css-extract-plugin
module.exports = {"profile":"Menubar_profile__3T8g8","navbar":"Menubar_navbar__2qI5u","body":"Menubar_body__pcLNY","textColor":"Menubar_textColor__3gRhr"};